import { ScreenContext, useCollection } from '@hb/react'
import { dotPhraseTemplatesCollection } from '@hb/shared'
import { useContext } from 'react'
import { EditCollection } from '../../EditCollection'
import { DotPhraseTemplateBody } from './DotPhraseTemplateBody'

export const DotPhraseTemplatesAdminView = () => {
  const { contentWidth } = useContext(ScreenContext)
  const data = useCollection(dotPhraseTemplatesCollection)
  if (!data) return null
  return (
    <EditCollection
      collection={dotPhraseTemplatesCollection}
      data={data}
      width={contentWidth}
      ItemComponent={DotPhraseTemplateBody}
      name="Dot Phrase Template Library"
      itemPlaceholder="keyword"
      itemName="Dot Phrase Template"
    />
  )
}
